import { defineParams } from "@sveltejs/kit/params";
import { validate } from "uuid";

export const params = defineParams({
	uuid: param => (validate(param) ? param : undefined),
});
